import { render, staticRenderFns } from "./customerTable.vue?vue&type=template&id=1a49425f&scoped=true"
import script from "./customerTable.vue?vue&type=script&lang=js"
export * from "./customerTable.vue?vue&type=script&lang=js"
import style0 from "./customerTable.vue?vue&type=style&index=0&id=1a49425f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a49425f",
  null
  
)

export default component.exports